/** Mahkeme seçim listesi: id sırası yerine görünen isim (Türkçe + sayısal parça) sırası */
export function sortMahkemelerByIsimAsc<T extends { isim?: string }>(list: T[]): T[] {
    return [...list].sort((a, b) =>
        String(a.isim || '').localeCompare(String(b.isim || ''), 'tr', {
            numeric: true,
            sensitivity: 'base',
        })
    );
}

export function isMahkemeApiAction(action: string | undefined | null): boolean {
    return typeof action === 'string' && action.includes('/mahkeme');
}
